<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav/>
      <div class="layout-container">
        <app-layout-navbar/>
        <div class="layout-content">
          <div
            class="router-transitions container-fluid flex-grow-1 container-p-y"
            style="position: relative;"
          >
            <router-view/>
          </div>
          <app-layout-footer/>
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
    <notifications group="notify-group" width="350" position="top right" style="top: 64px;"/>
    <signal-r/>
  </div>
</template>
<style src="@/vendor/styles/custom/style.scss" lang="scss"></style>

<script>
import LayoutNavbar from "./LayoutNavbar";
import LayoutSidenav from "./LayoutSidenav";
import LayoutFooter from "./LayoutFooter";
import SignalR from "../components/SignalR.vue";

export default {
  name: "layout",
  components: {
    "app-layout-navbar": LayoutNavbar,
    "app-layout-sidenav": LayoutSidenav,
    "app-layout-footer": LayoutFooter,
    "signal-r": SignalR
  },

  mounted() {
    this.layoutHelpers.init();
    this.layoutHelpers.update();
    this.layoutHelpers.setAutoUpdate(true);
  },

  beforeDestroy() {
    this.layoutHelpers.destroy();
  },

  methods: {
    closeSidenav() {
      this.layoutHelpers.setCollapsed(true);
    }
  }
};
</script>
